// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"LeadsWidget_confirmation__1-PKS","div":"LeadsWidget_div__3_WJZ"};